import { render, staticRenderFns } from "./stockLog.vue?vue&type=template&id=1f696ffc&"
import script from "./stockLog.vue?vue&type=script&lang=js&"
export * from "./stockLog.vue?vue&type=script&lang=js&"
import style0 from "./stockLog.vue?vue&type=style&index=0&id=1f696ffc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports